{
	"title": "Η συναλλαγή δεν βρέθηκε",
	"description": "Μεταβείτε στην επισκόπηση και εισαγάγετε ένα έγκυρο αναγνωριστικό συναλλαγής. Ένα αναγνωριστικό συναλλαγής μπορεί να βρεθεί σε μια δήλωση ή σε ένα τιμολόγιο.",
	"secondaryButtonTitle": "Εμφάνιση αρχικής σελίδας"
}
